module.exports = __webpack_public_path__ + "img/zsk (3).b33060bd.jpg";